function formatMoney(cents, format) {
  // Convert cents to dollars and fix to two decimal places
  const value = (cents / 100).toFixed(2);
  // Replace the placeholder in the format string with the value
  return format.replace('{{amount_with_comma_separator}}', value);
}